import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FBRightsCategoryBuilder from "../models/builders/FBRightsCategoryBuilder";
import styles from "../styles/addEditRightScreen.module.css";

const AddEditRightScreen = ({
  editRightCategory,
  addRightCategory,
  deleteRightCategory,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const rightCategory = location.state.rightCategory;
  const editMode = location.state.editMode;

  const [title, setTitle] = useState(
    rightCategory != null ? rightCategory.title : ""
  );
  const [subtitle, setSubtitle] = useState(
    rightCategory != null ? rightCategory.subtitle : ""
  );
  const [description, setDescription] = useState(
    rightCategory != null ? rightCategory.description : ""
  );
  const [showSave, setShowSave] = useState(!editMode);

  const checkIfContentWasEdited = (title, subtitle, description) => {
    return (
      rightCategory.title !== title ||
      rightCategory.subtitle !== subtitle ||
      rightCategory.description !== description
    );
  };

  const onChangeTitleText = (e) => {
    const enteredTitle = e.target.value;
    if (editMode) {
      setShowSave(checkIfContentWasEdited(enteredTitle, subtitle, description));
    }
    setTitle(e.target.value);
  };

  const onChangeSubtitleText = (e) => {
    const enteredSubtitle = e.target.value;
    if (editMode) {
      setShowSave(checkIfContentWasEdited(title, enteredSubtitle, description));
    }
    setSubtitle(e.target.value);
  };

  const onChangeDescriptionText = (e) => {
    const enteredDescription = e.target.value;
    if (editMode) {
      setShowSave(checkIfContentWasEdited(title, subtitle, enteredDescription));
    }
    setDescription(e.target.value);
  };

  const onClickCancel = () => {
    navigate(-1);
  };

  const isValidInput = () => {
    // we need an alert or validation in the form so that users know they have to have data inside of all the fields for it to work
    if (title === "" || subtitle === "" || description === "") {
      return false;
    }
    return true;
  };

  const onClickSave = () => {
    if (!isValidInput()) {
      // TODO: Display an error
      return;
    }
    const newRightCategory = FBRightsCategoryBuilder.buildFBRightsCategory(
      description,
      null,
      subtitle,
      title
    );
    if (editMode) {
      editRightCategory(newRightCategory, rightCategory, () => {
        navigate(-1);
      });
    } else {
      addRightCategory(newRightCategory, () => {
        navigate(-1);
      });
    }
  };

  const onClickDelete = () => {
    if (
      window.confirm("Are you sure you want to delete this right category?")
    ) {
      deleteRightCategory(rightCategory, () => {
        navigate(-1);
      });
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.innerContainer}>
        <p className={styles.title}>Right Category Information</p>
        <div className={styles.formContainer}>
          <div className={styles.fieldContainer}>
            <p className={styles.fieldLabel}>Title:</p>
            <input
              className={styles.inputStyle}
              type="text"
              value={title}
              onChange={onChangeTitleText}
            />
          </div>
          <div className={styles.fieldContainer}>
            <p className={styles.fieldLabel}>Subtitle:</p>
            <textarea
              className={styles.inputStyleArea}
              value={subtitle}
              onChange={onChangeSubtitleText}
            />
          </div>
          <div className={styles.fieldContainer}>
            <p className={styles.fieldLabel}>Description:</p>
            <textarea
              className={styles.inputStyleArea}
              value={description}
              onChange={onChangeDescriptionText}
            />
          </div>
          <div className={styles.buttonsContainer}>
            <div className={styles.cancelButton} onClick={onClickCancel}>
              Cancel
            </div>
            {editMode ? (
              <div className={styles.deleteButton} onClick={onClickDelete}>
                Delete
              </div>
            ) : null}
            {showSave ? (
              <div className={styles.saveButton} onClick={onClickSave}>
                Save
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEditRightScreen;
